<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="title"
    center
    width="624px"
    @close="handleClose"
    custom-class="account-dialog"
  >
    <template v-if="step !== 4">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="left"
        label-width="90px"
      >
        <el-form-item label="收款方式">
          <el-select
            v-model="form.type"
            v-if="step === 1 || step === 3"
            @change="changeOption"
          >
            <el-option
              v-for="item in accountList"
              :key="item.account_type"
              :label="item.account_type"
              :value="item.type"
            ></el-option>
          </el-select>
          <div class="input" v-if="step === 2">
            {{ form.account_type }}
          </div>
        </el-form-item>
        <el-form-item label="收款账户" v-if="step === 3">
          <span class="input edit-input" style="padding:0;">{{ dese_name }}</span>
          <span class="input edit-input">{{ dese_account }}</span>
          <span class="edit edit-input" @click="changeClick">修改</span>
        </el-form-item>
        <el-form-item label="账户类型" v-if="step === 2 && form.type === 3">
          <el-select v-model="form.is_public">
            <el-option
              v-for="item in accountType"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="step === 2"
          :label="
            form.type !== 3 ? '账户姓名' : form.is_public ? '公司名称' : '姓名'
          "
          prop="username"
        >
          <el-input
            v-model.trim="form.username"
            :placeholder="
              form.type !== 3
                ? '请输入账户姓名'
                : form.is_public
                ? '请输入公司名称'
                : '请输入开户人姓名'
            "
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="form.type !== 3 ? '收款账号' : '银行卡号'"
          v-if="step === 2"
          prop="account"
        >
          <el-input
            v-model.trim="form.account"
            :placeholder="'请输入' + form.account_type + '账号'"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="开户行"
          v-if="form.type === 3 && form.is_public && step === 2"
          prop="bank_code"
        >
          <el-select v-model="form.bank_code" filterable>
            <el-option
              v-for="(item, index) in bank_list"
              :key="index"
              :label="item.bank_name"
              :value="item.bank_code"
            ></el-option>
          </el-select>
        </el-form-item>
        <template v-if="form.type === 2 && step === 2">
          <el-form-item
            label="收款码"
            prop="qrcode"
          >
            <div class="uploadBox">
              <ossUploadFile
                class="upload"
                ref="upload"
                fileDir="images/payee"
                accept="image/jpeg, image/png"
                list-type="picture-card"
                :show-file-list="false"
                :limits="1"
                @upload="unloadLoanQrcode"
              >
                <template slot="default">
                  <img
                    v-if="form.qrcode"
                    :src="form.qrcode"
                    class="upload_image"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </template>
              </ossUploadFile>
              <div class="uploadBox-tip">
                点击上传微信收款码
              </div>
            </div>
          </el-form-item>
        </template>
        <template v-if="form.type === 2 && step === 3 && form.qrcode ">
          <el-form-item
            label="收款码"
            prop="qrcode"
            class="qrcode-form-item"
          >
            <div class="uploadBox">
              <img
                :src="form.qrcode"
                class="upload_image"
              />
              <span class="edit edit-input" @click="changeClick">修改</span>
            </div>
          </el-form-item>
        </template>

      </el-form>
      <div class="tips">
        <img src="@/assets/image/PersonalCenter/MyAccount/tips.png" alt=""/>
        <span class="word"
        >友情提示：放款金额打款至该账户内，为了保证及时高效放款，推荐使用支付宝</span
        >
      </div>
      <span slot="footer" class="btn-group">
        <div class="btn" @click="handleClose">取消</div>
        <button v-prevent-re-click class="btn confirm" @click="submit">
          确定
        </button>
      </span>
    </template>
    <template v-else>
      <div class="applying">
        <img
          src="@/assets/image/PersonalCenter/MyAccount/applying.png"
          alt=""
          class="apply-img"
        />
        <div class="title">放款申请中</div>
        <div class="time">预计两小时内放款</div>
        <div class="account">
          <div class="account-head">
            <img :src="form.logo" alt="" class="account-head-logo"/>
            <span class="account-head-type">{{ form.account_type }}</span>
            <span class="account-head-name" v-if="form.type === 3">{{
                form.bank_name
              }}</span>
          </div>
          <div class="account-detail">
            <span>{{ form.username }}</span>
            <span>{{ form.account }}</span>
          </div>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import AlipayLogo from "@/assets/image/PersonalCenter/MyAccount/ali.png";
import WeChatLogo from "@/assets/image/PersonalCenter/MyAccount/wechat.png";
import BankLogo from "@/assets/image/PersonalCenter/MyAccount/bank.png";
import desensitization from "@/util/strReplace"; // 数据脱敏
import {
  accountList,
  addAccount,
  editAccount,
  bankList,
  apiUserAccountLending,
} from "@/request/API";
import OssUploadFile from "@/components/ossUploadFile";

export default {
  props: {
    game_id: {
      type: [String, Number],
      default: "",
    },
    product_id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      step: 1, // 1 选择账户录入 2录入账户  3 选择了已经录入的账户  4 申请放款
      dialogVisible: false,
      form: {
        logo: AlipayLogo,
        type: 1, // 1: 支付宝    2微信  3银行卡
        account_type: "",
        is_public: 0,
        bank_code: "",
        username: "",
        account: "",
        qrcode: '',
      },
      accountList: [
        {
          logo: AlipayLogo,
          account_type: "支付宝",
          username: "",
          account: "",
          bank_code: "",
          bank_cnaps_code: "",
          is_public: 0,
          type: 1,
          user_id: "",
          id: "",
        },
        {
          logo: WeChatLogo,
          account_type: "微信",
          username: "",
          account: "",
          bank_code: "",
          bank_cnaps_code: "",
          is_public: 0,
          type: 2,
          user_id: "",
          id: "",
        },
        {
          logo: BankLogo,
          account_type: "银行卡",
          username: "",
          account: "",
          bank_code: "",
          bank_cnaps_code: "",
          opening_bank: "",
          is_public: 0,
          type: 3,
          user_id: "",
          id: "",
        },
      ],
      accountType: [
        {label: "个人账户", value: 0},
        {label: "公司账户", value: 1},
      ],
      //   rules: {},
      bank_list: [],
      source: "list",
      isEdite: false,
    };
  },
  components: {
    OssUploadFile
  },
  computed: {
    dese_name() {
      return desensitization("name", this.form.username);
    },
    dese_account() {
      var type =
        this.form.type === 1 ? "ali" : this.form.type === 2 ? "wx" : "bank";
      return desensitization(type, this.form.account);
    },
    title() {
      switch (this.step) {
        case 1:
        case 3:
          return "选择收款方式";
        case 2:
          return "录入收款账户";
        case 4:
          return "放款申请中";
      }
      return "";
    },
    bankInfo() {
      if (this.form.type === 3 && this.bank_list.length) {
        return (
          this.bank_list.filter(
            (item) => item.bank_code === this.form.bank_code
          )[0] || {}
        );
      }
      return {};
    },
    rules() {
      switch (this.form.type) {
        case 1:
          return {
            username: [
              {required: true, message: "请输入账户姓名", trigger: "blur"},
              {
                pattern: /^[\u4e00-\u9fa5·]{2,30}$/,
                message: "请输入正确的中文姓名",
                trigger: "blur",
              },
            ],
            account: [
              {required: true, message: "请输入收款账号", trigger: "blur"},
              {
                pattern:
                  this.form.type === 2
                    ? /^[0-9a-zA-Z]{1}[-_a-zA-Z0-9]{5,19}$/
                    : /^(?:\w+\.?)*\w+@(?:\w+\.)+\w+|1[3456789]\d{9}$/,
                message:
                  this.form.type === 2
                    ? "请输入正确的微信账号"
                    : "请输入正确的支付宝账号",
                trigger: "blur",
              },
            ],
          };
        case 2:
          if (this.step === 2) {
            return {
              username: [
                {required: true, message: "请输入账户姓名", trigger: "blur"},
                {
                  pattern: /^[\u4e00-\u9fa5·]{2,30}$/,
                  message: "请输入正确的中文姓名",
                  trigger: "blur",
                },
              ],
              account: [
                {required: true, message: "请输入收款账号", trigger: "blur"},
                {
                  pattern:
                    this.form.type === 2
                      ? /^[0-9a-zA-Z]{1}[-_a-zA-Z0-9]{5,19}$/
                      : /^(?:\w+\.?)*\w+@(?:\w+\.)+\w+|1[3456789]\d{9}$/,
                  message:
                    this.form.type === 2
                      ? "请输入正确的微信账号"
                      : "请输入正确的支付宝账号",
                  trigger: "blur",
                },
              ],
              qrcode: [
                {required: true, message: "请上传微信收款码", trigger: "change"},
              ],
            };
          }else{
            return
          }
        case 3:
          var username = [
            {
              required: true,
              message: this.form.is_public
                ? "请输入公司名称"
                : "请输入开户人姓名",
              trigger: "blur",
            },
          ];
          if (!this.form.is_public)
            username.push({
              pattern: /^[\u4e00-\u9fa5·]{2,30}$/,
              message: "请输入正确的开户人姓名",
              trigger: "blur",
            });
          return {
            username,
            account: [
              {
                required: true,
                message: "请输入银行卡账号",
                trigger: "blur",
              },
              {
                pattern: /^([1-9]{1})(\d{14}|\d{15}|\d{16}|\d{17}|\d{18})$/,
                message: "请输入正确的银行卡号",
                trigger: "blur",
              },
            ],
            bank_code: [
              {required: true, message: "请选择开户行", trigger: "change"},
            ],
          };
        default:
          return {};
      }
    },
  },
  methods: {
    /**
     * 微信-上传收款二维码
     * @param file 文件
     */
    async unloadLoanQrcode(url) {
      // this.form.qrcode = url;
      this.$set(this.form,'qrcode',url)
    },
    // 关闭dialog
    handleClose() {
      this.step = 1;
      this.isEdite = false;
      this.dialogVisible = false;
    },
    //  打开dialog
    open(data) {
      if (data) {
        this.form = {...data};
        //  如果是更换认证
        if (data.account) {
          this.isEdite = true;
        } else {
          this.isEdite = false;
        }
        this.step = 2;
        //  从个人中心打开
        this.source = "personCenter";
      }
      this.getAccount();
      this.getBankList();
      this.dialogVisible = true;
    },
    // 点击修改
    changeClick() {
      this.step = 2;
      this.isEdite = true;
    },
    //  更换放款方式
    changeOption(type) {
      var item = this.accountList.filter((item) => item.type === type)[0];
      this.form = {...item};
      //  如果未录入跳到step2去录入
      if (!item.account && this.step === 3) {
        this.step = 2;
      }
    },
    //  获取用户账户列表
    getAccount() {
      accountList()
        .then((res) => {
          res.data.length &&
          res.data.forEach((item, index) => {
            //  默认从账号列表打开
            if (this.source === "list" && index === 0) {
              this.form = {
                ...item,
                account_type:
                  item.type === 1
                    ? "支付宝"
                    : item.type === 2
                    ? "微信"
                    : "银行卡",
                logo: item.type === 1 ? AlipayLogo : item.type === 2 ? WeChatLogo : BankLogo,
              };
              //  如果已录入跳到编辑页面
              this.step = 3;
            }

            this.accountList.forEach((el) => {
              if (item.type === el.type) {
                el.username = item.username;
                el.account = item.account;
                el.bank_code = item.bank_code;
                el.bank_cnaps_code = item.bank_cnaps_code;
                el.opening_bank = item.opening_bank;
                el.is_public = item.is_public;
                el.user_id = item.user_id;
                el.id = item.id;
                el.qrcode = item.qrcode;
                el.bank_name = item.bank_name;
              }
            });
          });
        })
        .catch((err) => {
          this.$message({
            message: err.msg,
            center: true,
            type: "error",
          });
        });
    },
    // 获取银行列表
    getBankList() {
      bankList()
        .then((res) => {
          this.bank_list = res.data;
        })
        .catch((err) => {
          this.$message({
            message: err.msg,
            center: true,
            type: "error",
          });
        });
    },
    //  确定按钮
    submit() {
      switch (this.step) {
        case 1:
          this.step++;
          break;
        case 2:
          this.$refs.form.validate((validate) => {
            if (validate) {
              if (this.isEdite) return this.changeAccount();
              addAccount({
                username: this.form.username,
                account: this.form.account,
                type: this.form.type,
                is_public: this.form.is_public,
                bank_code: this.form.bank_code,
                bank_cnaps_code: this.bankInfo?.bank_cnaps_code || "",
                bank_name: this.bankInfo?.bank_name || "",
                qrcode: this.form.type === 2 ? this.form.qrcode : "",
              })
                .then((res) => {
                  this.$message({
                    message: "新增账户成功",
                    center: true,
                    type: "success",
                  });
                  if (this.source === "list") {
                    this.step++;
                    this.form.id = res.data.id;
                    this.getAccount()
                  } else {
                    //  刷新父组件数据
                    this.$emit("refresh");
                    // 关闭弹窗
                    this.handleClose();
                  }
                })
                .catch((err) => {
                  this.$message({
                    message: err.msg,
                    center: true,
                    type: "error",
                  });
                });
            }
          });
          break;
        case 3:
          apiUserAccountLending({
            game_id: this.game_id,
            product_id: this.product_id,
            user_account_id: this.form.id,
          })
            .then((res) => {
              this.$message({
                center: true,
                type: "success",
                message: "申请放款成功",
              });
              this.$emit("refresh");
              this.step++;
            })
            .catch((e) => {
              this.$message({
                center: true,
                type: "error",
                message: e.msg,
              });
            });
          break;
      }
    },
    //  修改账户
    changeAccount() {
      editAccount({
        username: this.form.username,
        account: this.form.account,
        type: this.form.type,
        is_public: this.form.is_public,
        bank_code: !this.form.is_public ? '' : this.form.bank_code,
        bank_cnaps_code: !this.form.is_public ? '' : this.bankInfo?.bank_cnaps_code || "",
        bank_name: !this.form.is_public ? '' : this.bankInfo?.bank_name || "",
        qrcode: this.form.type === 2 ? this.form.qrcode : "",
        id: this.form.id,
      })
        .then((res) => {
          this.$message({
            message: "修改账户成功",
            center: true,
            type: "success",
          });
          this.isEdite = false;
          if (this.source === "list") {
            this.step++;
            this.form.id = res.data.id;
          } else {
            //  刷新父组件数据
            this.$emit("refresh");
            // 关闭弹窗
            this.handleClose();
          }
        })
        .catch((err) => {
          this.$message({
            message: err.msg,
            center: true,
            type: "error",
          });
        });
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .account-dialog {
  overflow: hidden;
  border-radius: 4px;
  box-shadow: none;
  filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));
  font-family: PingFang SC-Regular, PingFang SC;

  .el-dialog__header {
    height: 56px;
    line-height: 56px;
    text-align: center;
    background: var(--bg-dark, #1A1D24);
    position: relative;
    padding: 0;
    border-radius: 4px 4px 0 0;

    .el-dialog__title {
      font-size: 18px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      letter-spacing: 1px;
    }

    .el-dialog__headerbtn {
      position: absolute;
      right: 20px;
      top: 18px;
      width: 20px;
      height: 20px;

      .el-icon {
        font-size: 18px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.86);
        transition: color .2s ease, transform .2s ease;
      }
    }

    .el-dialog__headerbtn:hover .el-icon {
      color: #ffffff;
      transform: rotate(90deg);
    }
  }

  .el-dialog__body {
    padding: 34px 72px 22px;
    background: var(--bg-card, #FFFFFF);

    .el-select {
      width: 100%;
    }

    .el-input__inner {
      height: 40px;
      padding: 0 14px;
      background: var(--bg-tag, #F0EDE8);
      border-radius: 4px;
      border: 1px solid var(--border-soft, #E8E4DE);
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-main, #111827);
      transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
    }

    .el-input__inner:hover {
      border-color: var(--border-strong, #D8D2CA);
      background: #FFFFFF;
    }

    .el-input__inner:focus {
      border-color: var(--primary, #FF5A1F);
      background: #FFFFFF;
      box-shadow: none;
    }

    .el-form-item {
      margin-bottom: 20px;
    }

    .el-form {
      &-item {
        &__label {
          padding: 0 16px 0 0;
          color: var(--text-secondary, #5A5F6B);
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 40px;
        }

        &__content {
          min-height: 40px;
          line-height: 40px;
        }

        &__error {
          padding-top: 5px;
          color: var(--danger, #EF4444);
        }
      }
    }

    .is-error .el-input__inner {
      border-color: var(--danger, #EF4444);
      box-shadow: none;
    }

    .input {
      color: var(--text-main, #111827);
      font-weight: 400;
      font-size: 15px;
    }

    .edit-input {
      padding-left: 14px;
      font-weight: 400;
    }

    .edit {
      color: var(--primary, #FF5A1F);
      font-weight: 500;
      cursor: pointer;
      transition: color .2s ease;
    }

    .edit:hover {
      color: var(--primary-hover, #E84A12);
    }
  }

  .tips {
    width: 100%;
    min-height: 34px;
    background: var(--bg-tag, #F0EDE8);
    margin: auto;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #1A1D24);
    border-radius: 4px;

    .word {
      padding-left: 6px;
      line-height: 18px;
    }
  }

  .btn-group {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 0 8px;

    .btn {
      width: 158px;
      height: 38px;
      border: 1.5px solid var(--bg-dark, #1A1D24);
      background: #FFFFFF;
      cursor: pointer;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #1A1D24);
      user-select: none;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color .2s ease, background .2s ease, border-color .2s ease, box-shadow .2s ease, opacity .2s ease;
    }

    .btn:hover {
      border-color: var(--bg-dark, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    .confirm {
      border: none;
      background: var(--primary, #FF5A1F);
      box-shadow: none;
      color: #FFFFFF;
      margin: 0 0 0 15px;
    }

    .confirm:hover {
      background: var(--primary-hover, #E84A12);
      border: none;
      box-shadow: none;
      color: #FFFFFF;
    }
  }

  .applying {
    text-align: center;
    font-family: PingFang SC-Semibold, PingFang SC;

    .title {
      font-size: 20px;
      font-weight: 600;
      color: var(--text-main, #111827);
      height: 28px;
      line-height: 23px;
      margin-top: 23px;
    }

    .time {
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      height: 20px;
      line-height: 16px;
      margin-top: 6px;
    }

    .account {
      width: 351px;
      height: fit-content;
      padding: 15px 30px;
      margin: 40px auto;
      text-align: left;
      box-sizing: border-box;
      background: var(--bg-tag, #F0EDE8);
      border: 1px solid var(--border-soft, #E8E4DE);
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      border-radius: 4px;

      &-head {
        display: flex;
        align-items: center;

        &-logo {
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }

        &-type,
        &-name {
          font-weight: 500;
          color: var(--text-main, #111827);
          padding-left: 8px;
        }
      }

      &-detail {
        margin-top: 8px;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);

        span:last-child {
          padding-left: 10px;
        }
      }
    }
  }

  /deep/.qrcode-form-item{
    height: 70px;
    line-height: 70px;
  }
  //上传
  .uploadBox {
    display: flex;
    align-items: center;

    .upload {

      .el-upload--picture-card {
        width: 70px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: normal;
        background: var(--bg-tag, #F0EDE8);
        border: 1px dashed var(--border-soft, #E8E4DE);
        border-radius: 4px;
        transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
      }

      .avatar-uploader-icon {
        font-size: 22px;
        line-height: 1;
        color: var(--text-muted, #9AA0AC);
      }

      .upload_image {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
      }

      .el-upload--picture-card:focus,
      .el-upload--picture-card:hover {
        border-color: var(--primary, #FF5A1F);
        background: #FFFFFF;
        box-shadow: none;

        i {
          color: var(--primary, #FF5A1F);
        }
      }
    }

    .upload_image{
      width: 70px;
      height: 70px;
      border-radius: 4px;
      object-fit: cover;
    }

    .edit {
      color: var(--primary, #FF5A1F);
      font-weight: 500;
      cursor: pointer;
      transition: color .2s ease;
    }

    .edit:hover {
      color: var(--primary-hover, #E84A12);
    }

    &-tip {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-muted, #9AA0AC);
      margin: 0 0 0 8px;
    }

  }
}
</style>
